import * as Dialog from "@radix-ui/react-dialog";
import styled from "styled-components";
import { COLORS } from "../../../../header/header.styled";

export const ModalOverlay = styled(Dialog.Overlay)`
    position: fixed;
    inset: 0;
    @media (min-width: 768px) { left: var(--sidebar-width, 0px); }
    background: rgba(10, 12, 16, 0.55);
    -webkit-backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
    z-index: 1002;
`;

export const ModalContent = styled(Dialog.Content)`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media (min-width: 768px) { left: calc(50% + var(--sidebar-width, 0px) / 2); }
    width: calc(100% - 64px);
    color: #0f1116;
    border-radius: 16px;
    border: 1px solid rgba(15, 17, 22, 0.08);
    box-shadow: 0 24px 72px rgba(0, 0, 0, 0.35);
    padding: 20px;
    z-index: 1003;
    background: ${COLORS.surface};
    display: flex;
    gap: 16px;
    flex-direction: column;
`;

export const ModalActions = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 12px;
`;

export const DangerBtn = styled.button`
    -webkit-appearance: none;
    appearance: none;
    border: none;
    background: #d65f46;
    color: #fff;
    padding: 10px 14px;
    border-radius: 10px;
    font-size: 14px;
    cursor: pointer;
`;
